var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavbarBubbleMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 83 247.6",
    style: {
      enableBackground: "new 0 0 83 247.6"
    },
    xmlSpace: "preserve",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83,247.6c0-34.4-6-64.8-24-64.8c-28,0-59-22-59-59c0-37,31-59,59-59c18,0,24-30.4,24-64.8V247.6z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarBubbleMask);
export default __webpack_public_path__ + "static/media/navbar-bubble-mask.363b1698.svg";
export { ForwardRef as ReactComponent };